import _ from 'lodash';
import moment from 'moment';

const DASHBOARD_DATE_FORMATS = [
  'M/D/YYYY',
  'MM/DD/YYYY',
  'M/D/YY',
  'MM/DD/YY',
  'YYYY-MM-DD',
  'YYYY-MM-DD HH:mm:ss'
];

export const parseDashboardDate = value => {
  if (!value) {
    return null;
  }

  if (moment.isMoment(value)) {
    return value.isValid() ? value : null;
  }

  if (value instanceof Date || typeof value === 'number') {
    const parsed = moment(value);
    return parsed.isValid() ? parsed : null;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const isoParsed = moment(trimmed, moment.ISO_8601, true);
  if (isoParsed.isValid()) {
    return isoParsed;
  }

  const formattedParsed = moment(trimmed, DASHBOARD_DATE_FORMATS, true);
  return formattedParsed.isValid() ? formattedParsed : null;
};

export const getLatestDashboardDateLabel = items => {
  const latestItem = _.maxBy(items || [], item => {
    const created = item?.created || item?.Created || item?.last_updated;
    const parsed = parseDashboardDate(created);
    return parsed ? parsed.valueOf() : 0;
  });
  const created =
    latestItem?.created || latestItem?.Created || latestItem?.last_updated;
  const parsed = parseDashboardDate(created);

  if (!parsed) {
    return 'No recent activity';
  }

  return `Latest ${parsed.format('MMM D, YYYY')}`;
};
